import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { ROLE_PERMISSIONS } from '../auth0-config/role-permission.config';
import { JwtDecodeService } from './jwt-decode.service';
import { getCookie } from '@auth/bp-pf-auth';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private loaded = false;

  private permission: any = {
    menus: {},
    tabs: {},
    pages: {},
    actions: {}
  };

  constructor(private jwtDecodeService: JwtDecodeService) {
  }

  loadPermissions(): void {
    const pathSegments = window.location.pathname.split('/');
    const tenant = getCookie(`${environment.app_id}_tenant_code`);
    const token = getCookie(`${tenant}_${environment.app_id}_access_token`);
    if (!token) {
      return;
    }
    this.loaded = true;
    const decoded: any = this.jwtDecodeService.decodeJWTToken(token);
    const roles: string[] = decoded["https://pf_bp/roles"] || [];
    if (roles.length === 0) {
      this.permission = {
        menus: new Proxy({}, {
          get: () => true
        }),
        tabs: new Proxy({}, {
          get: () => true
        }),
        pages: new Proxy({}, {
          get: () => true
        }),
        actions: new Proxy({}, {
          get: () => true
        })
      };
      return;
    }

    this.permission = {
      menus: {},
      tabs: {},
      pages: {},
      actions: {}
    };
    roles.forEach(role => {
      const rolePermission = ROLE_PERMISSIONS[role];
      if (!rolePermission) {
        return;
      }

      this.merge(this.permission.menus, rolePermission.menus);

      this.merge(this.permission.tabs, rolePermission.tabs);

      this.merge(this.permission.pages, rolePermission.pages);

      this.merge(this.permission.actions, rolePermission.actions);

    });

  }

  private merge(target: any, source: any) {
    Object.keys(source).forEach(key => {
      target[key] = target[key] || source[key];
    });
  }

  hasMenu(menu: string): boolean {
    return !!this.permission.menus[menu];
  }

  hasTab(tab: string): boolean {
    return !!this.permission.tabs[tab];
  }

  hasPage(page: string): boolean {
    return !!this.permission.pages[page];
  }

  hasAction(action: string): boolean {
    return !!this.permission.actions[action];
  }

  getPermissions(): any {
    return this.permission;
  }

  ensureLoaded(): void {
    if (!this.loaded) {
      this.loadPermissions();
    }
  }
}
